import t from"react";const e=t.createContext({inverted:void 0});export{e as PopoverContext};
